export const setClientSignature = (payload) => {
  return { type: "SET_CLIENT_SIGNATURE", payload };
};

export const setContractDetails = (payload) => {
  return { type: "SET_CONTRACT_DETAILS", payload };
};
